import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
} from "@mui/material";

export default function SOPRejectDialog({
  open,
  rejectionReason,
  setRejectionReason,
  onClose,
  onConfirm,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Explain what needs to be changed before this SOP can be approved.
        </Typography>

        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          label="Reason for rejection"
          value={rejectionReason}
          onChange={(e) => setRejectionReason(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Reject SOP
        </Button>
      </DialogActions>
    </Dialog>
  );
}